export const toastMessages = {
  assessment: {
    created: { title: 'Assessment created successfully!' },
    updated: { title: 'Assessment updated successfully!' },
    deleted: { title: 'Assessment deleted successfully!' },
    duplicated: { title: 'Assessment duplicated successfully!' },
    published: { title: 'Version published successfully!' },
  },
  scenario: {
    created: { title: 'Scenario created successfully!' },
    createdPlural: { title: 'Scenarios created successfully!' },
    added: { title: 'Scenario added successfully!' },
    addedPlural: { title: 'Scenarios added successfully!' },
    updated: { title: 'Scenario updated successfully!' },
    deleted: { title: 'Scenario deleted successfully!' },
    linked: { title: 'Scenarios linked successfully!' },
    unlinked: { title: 'Scenario unlinked successfully!' },
  },
  control: {
    created: { title: 'Control created successfully!' },
    createdPlural: { title: 'Controls created successfully!' },
    updated: { title: 'Control updated successfully!' },
    deleted: { title: 'Controls deleted successfully!' },
    linked: { title: 'Controls linked successfully!' },
    addedToRmp: { title: 'Control added to RMP successfully!', subtitle: 'Go to your RMP to access this control' },
    addedToRmpPlural: {
      title: 'Controls added to RMP successfully!',
      subtitle: 'Go to your RMP to access these controls',
    },
    bulkUpdated: { title: 'Controls updated successfully!' },
    unlinked: { title: 'Control unlinked successfully!' },
  },
  incident: {
    created: { title: 'Incident created successfully!' },
    createdPlural: { title: 'Incidents created successfully!' },
    updated: { title: 'Incident updated successfully!' },
    deleted: { title: 'Incident deleted successfully!' },
    linked: { title: 'Incidents linked successfully!' },
    unlinked: { title: 'Incident unlinked successfully!' },
  },
  action: {
    created: { title: 'Action added successfully!' },
    updated: { title: 'Action updated successfully!' },
    completed: { title: 'Action complete!' },
  },
  framework: {
    linked: { title: 'Framework linked successfully!' },
    saved: { title: 'Framework preferences saved successfully!' },
  },
  riskStrategy: {
    saved: { title: 'Risk strategy saved successfully!' },
  },
  riskTolerance: {
    saved: { title: 'Risk tolerance saved successfully!' },
  },
  execSummary: {
    saved: { title: 'Executive summary saved successfully!' },
  },
  variables: {
    saved: { title: 'Variables saved successfully!' },
  },
  user: {
    invited: { title: 'User invited successfully!' },
    updated: { title: 'User updated successfully!' },
    removed: { title: 'User removed successfully!' },
    inviteCancelled: { title: 'Invite cancelled successfully!' },
    requestAccepted: { title: 'Request accepted successfully!' },
    requestRejected: { title: 'Request rejected successfully!' },
    adminGranted: { title: 'Admin access granted successfully!' },
  },
  workspace: {
    created: { title: 'Workspace created successfully!' },
    updated: { title: 'Workspace updated successfully!' },
    archived: { title: 'Workspace archived successfully!' },
    unarchived: { title: 'Workspace unarchived successfully!' },
    deleted: { title: 'Workspace deleted successfully!' },
    digestSent: { title: 'Email sent!', subtitle: 'The user will receive the email if they have turned on notifications' },
    accessRequested: { title: 'Access requested successfully!' },
    inviteAccepted: { title: 'Invite accepted successfully!' },
  },
  organisation: {
    created: { title: 'Organisation created successfully!' },
    updated: { title: 'Organisation updated successfully!' },
    archived: { title: 'Organisation archived successfully!' },
  },
  comment: {
    added: { title: 'Comment added successfully!' },
    updated: { title: 'Comment updated successfully!' },
    deleted: { title: 'Comment deleted successfully!' },
  },
  assistance: {
    submitted: { title: 'Request submitted successfully!' },
  },
  modifier: {
    saved: { title: 'Modifiers saved successfully!' },
    recalculated: { title: 'Recalculation complete!' },
  },
  audit: {
    deleted: { title: 'Audit entry deleted successfully!' },
  },
  export: {
    // Create + create-failure cases use the dedicated showReportBuildingToast /
    // showReportFailedToast variants for the report-flavoured yellow/red styling.
    deleted: { title: 'Export deleted successfully!' },
    deleteFailed: { title: 'Could not delete export', subtitle: 'Please try again or contact support if the problem persists.' },
    downloadFailed: { title: 'Could not download export', subtitle: 'Please try again or contact support if the problem persists.' },
  },
} as const;
